import { lazy } from 'react'
import withSuspense from './HOC/withSuspense'
// import retryChunkLoadWrapper from './services';

// export const LoginPage = withSuspense(
//   lazy(() =>
//     retryChunkLoadWrapper(
//       () => import(/* webpackChunkName: "Login" */ '~/pages/Login/Login'),
//     ),
//   ),
//   true,
// );

export const DashboardPage = withSuspense(
  lazy(
    () =>
      // retryChunkLoadWrapper(
      //   () =>
      import(/* webpackChunkName: "Dashboard" */ '../modules/Dashboard/Dashboard')
    // ),
  )
)

export const OrganizationPage = withSuspense(
  lazy(
    () =>
      // retryChunkLoadWrapper(
      //   () =>
      import(
        /* webpackChunkName: "OrganizationDetails" */ '../modules/OrganizationDetails/OrganizationDetails'
      )
    // ),
  )
)

// export const FourOFourPage = withSuspense(
//   lazy(() =>
//     retryChunkLoadWrapper(
//       () =>
//         import(
//           /* webpackChunkName: "FourOFour" */ '~/pages/FourOFour/FourOFour'
//         ),
//     ),
//   ),
// );

export const QGisPage = withSuspense(
  lazy(
    () =>
      // retryChunkLoadWrapper(
      // () =>
      import(/* webpackChunkName: "QGis" */ '../modules/QGis/QGis')
    // ),
  )
)

export const SigninPage = withSuspense(
  lazy(
    () =>
      // retryChunkLoadWrapper(
      //   () =>
      import(/* webpackChunkName: "Dashboard" */ '../modules/Signin/Signin')
    // ),
  )
)

export const AOIPage = withSuspense(
  lazy(
    () =>
      // retryChunkLoadWrapper(
      //   () =>
      import(/* webpackChunkName: "AOI" */ '../modules/AOI/AOI')
    // ),)
  )
)

export const SitePage = withSuspense(
  lazy(
    () =>
      // retryChunkLoadWrapper(
      //   () =>
      import(/* webpackChunkName: "Site" */ '../modules/Site/Site')
    // ),)
  )
)
